function pdpSwatchesAddCallback(d){
  var keys = d.items.map(i => i.key);
  fetch('/cart?view=ajax.success-2', {
    credentials: 'same-origin',
    method: "GET",
    headers: {"Content-type": "text/html; charset=UTF-8"}
  }).then((data) => data.text()).then((data) => {
    var html = hwDOMParser.parseFromString(data, 'text/html');
    var atcEl = html.getElementById('atc-success');
    var swatchesContent = document.getElementById('swatches-popup-content');
    var popupBox = document.querySelector('.pdp-popup');
    var cartCount = atcEl.dataset.cartCount;
    var cartDot = document.querySelector('.Header__CartDot');
    swatchesContent.innerHTML = '';
    swatchesContent.appendChild(atcEl);
    atcEl.querySelectorAll('.atc-item').forEach((el) => {
      var key = el.dataset.key;
      if(!keys.includes(key)){
        el.remove();
      } else {
        el.querySelector('.atc-item__qty').textContent = "1";
      }
    });

    popupBox.classList.add('pdp-popup--narrow');
    popupBox.classList.remove('pdp-popup--medium');
    atcEl.classList.remove('hide');

    cartDot.textContent = cartCount;
    cartDot.classList.add('is-visible');
    document.querySelector('.atc-success__close').addEventListener('click',() => {
      pdpSwatchPopupClose();
    });
  });
}

function pdpSwatchPopupClose(){
  const popup = document.getElementById('pdp-popup');
  hwCancelTrapFocus(popup);
  popup.remove();
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}

function pdpSwatchesPopupInit(url){
  var pdpSwatchesTrigger = document.querySelector('.pdp-swatches-trigger');
  if(pdpSwatchesTrigger){
    pdpSwatchesTrigger.addEventListener('click',(triggerEvt) => {
      triggerEvt.preventDefault();
      fetch(`${url}?view=ajax.swatches`).then((response) => response.text()).then((text) => {
        var html = hwDOMParser.parseFromString(text,'text/html');
        var popup = html.getElementById('pdp-popup');
        document.body.append(popup);
        var popupClose = document.getElementById('pdp-popup-close');
        hwTrapFocus(popup);
        popupClose.addEventListener('click',() => {
          pdpSwatchPopupClose();
          triggerEvt.target.focus();
        });

        var addBtn = document.getElementById('swatches-add');
        addBtn.addEventListener('click',() => {
          var addObj = {items:[]};
          document.querySelectorAll('input[name="swatch-id"]:checked').forEach((input) => {
            var item = {
              id: input.value,
              quantity: 1
            };
            addObj.items.push(item);
          });

          if(addObj.items.length > 0){
            pdpExecuteAdd(addObj,addBtn,pdpSwatchesAddCallback);
          } else {
            alert('Please select at least one swatch to add.');
          }
        });
      });
    });
  }
}

window.addEventListener('DOMContentLoaded',() => {
  if(pdpProduct.domain && pdpProduct.path){
    url = `${pdpProduct.domain}${pdpProduct.path}`;
    pdpSwatchesPopupInit(url);
  }
});